module.exports = require('./$.hide');


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.redefine.js
// module id = ./node_modules/core-js/library/modules/$.redefine.js
// module chunks = 2